/**
 * PrioridadBadge — Badge visual de prioridad de orden.
 * STAT=rojo, URGENTE=naranja, NORMAL=verde
 *
 * Requirements: M4.1.6
 */

import { Badge } from "@/components/ui/badge";
import { getBadgeVariantPrioridad } from "../utils/cola-sorting";

interface PrioridadBadgeProps {
  prioridad: string;
  className?: string;
}

const PRIORIDAD_LABELS: Record<string, string> = {
  STAT: "STAT",
  URGENTE: "URGENTE",
  NORMAL: "NORMAL",
};

export function PrioridadBadge({ prioridad, className }: PrioridadBadgeProps) {
  const variant = getBadgeVariantPrioridad(prioridad);
  const label = PRIORIDAD_LABELS[prioridad] ?? prioridad;

  return (
    <Badge
      variant={variant}
      className={`min-w-[70px] justify-center font-semibold ${className ?? ""}`}
    >
      {label}
    </Badge>
  );
}
